/**
 * Logout Page (Dual Token Support)
 *
 * 문서 참고: coin-server/docs/frontend/REFRESH_TOKEN_MIGRATION_GUIDE.md
 */
import React, { useContext, useEffect, useRef } from 'react';
import { useToken } from '../hooks';
import { ThemeContext } from '../../theme/ThemeProvider';
import {
  ContentContainer,
  ContentWrapper,
} from '../../styles/globalPage-styles';
import { Header } from '../organisms';
import { Modal, Space, Spin } from 'antd';
import { IconCircleXFilled } from '@tabler/icons-react';
import { USER_LOG_TYPE, useUserLogger } from '../hooks/userLogger';
import apiClient from '@utils/apiClient';
import { activityLogger } from '../../utils/activityLogger';

const Logout = ({}: any) => {
  const { accessToken, refreshToken, removeTokens } = useToken(); // ✅ NEW: Dual Token
  const { mutateUserLog } = useUserLogger();
  const hasLoggedOut = useRef(false); // 중복 실행 방지 (React StrictMode 대응)

  useEffect(() => {
    // 이미 로그아웃 처리됨 - 중복 방지
    if (hasLoggedOut.current) return;

    if (accessToken) {
      hasLoggedOut.current = true; // 즉시 플래그 설정

      // 사용자 로그 기록
      mutateUserLog({
        log: USER_LOG_TYPE.LOGOUT,
        data: '',
        token: accessToken, // Legacy 호환성
      });

      // activityLogger 로그아웃 기록 (토큰 삭제 전에 호출!)
      // accessToken을 전달하여 버퍼에 쌓인 로그도 userId와 함께 전송
      activityLogger.logLogout(accessToken);

      // ✅ NEW: 서버에 로그아웃 요청 (Refresh Token 포함)
      apiClient
        .post('/auth/logout', {
          refreshToken: refreshToken, // ✅ Refresh Token도 함께 전송
        })
        .then(() => {
          console.log('[Logout] Server logout successful');
        })
        .catch((error) => {
          console.error('[Logout] Server logout failed:', error);
          // 실패해도 로컬 토큰은 삭제
        });

      // ✅ NEW: 로컬 토큰 삭제 (Access + Refresh)
      removeTokens();

      window.history.replaceState({}, document.title);
      window.location.href = '/';
    } else {
      // 토큰 없으면 바로 리다이렉트
      setTimeout(() => {
        window.location.href = '/';
      }, 800);
    }
  }, [accessToken, refreshToken, removeTokens, mutateUserLog]);

  const { isDarkMode, theme } = useContext(ThemeContext);
  const [visible, setVisible] = React.useState(false);

  return (
    <ContentContainer isDarkMode={isDarkMode}>
      <Header showSelect={visible} setShowSelect={setVisible} />
      <ContentWrapper>
        <div
          style={{
            flex: 1,

            justifyContent: 'center',
            width: '100%',
            height: '100%',
            color: theme.COLORS.textw,
            alignItems: 'center',
            marginTop: 30,
            justifyItems: 'center',
            textAlign: 'center',
          }}
        >
          <Spin size="large">Redirecting..</Spin>
          <Modal
            open={true}
            footer={null}
            closeIcon={null}
            closable={false}
            centered
          >
            <Space direction="vertical">
              <Space style={{ fontWeight: 'bold' }}>
                <IconCircleXFilled color="red" />
                SESSION EXPIRED
              </Space>

              <Space>
                세션이 만료되었습니다. 잠시 뒤 로그인 페이지로 이동합니다.
              </Space>
            </Space>
          </Modal>
        </div>
      </ContentWrapper>
    </ContentContainer>
  );
};
export default Logout;
